// Iris — force l'utilisateur à sélectionner une taille avant d'ajouter au panier.
// Au chargement : désélectionne tous les radios "option" (tailles).
// Met à jour le bouton ATC : "Sélectionnez votre taille" (disabled) tant que
// toutes les options n'ont pas de valeur cochée.

(function () {
  var LABEL_BUY = 'Ajouter au panier';
  var LABEL_NEED_SIZE = 'Sélectionnez votre taille';

  function setAtcState(formId, hasVariant) {
    document
      .querySelectorAll('buy-buttons[form="' + formId + '"]')
      .forEach(function (bb) {
        var labelEl = bb.querySelector('.iris-atc-label');
        var sepEl = bb.querySelector('.iris-atc-sep');
        var priceEl = bb.querySelector('.iris-atc-price');
        var btn = bb.querySelector('button[type="submit"], input[type="submit"]');
        if (hasVariant) {
          if (labelEl) labelEl.textContent = LABEL_BUY;
          if (sepEl) sepEl.style.display = '';
          if (priceEl) priceEl.style.display = '';
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
          }
        } else {
          if (labelEl) labelEl.textContent = LABEL_NEED_SIZE;
          if (sepEl) sepEl.style.display = 'none';
          if (priceEl) priceEl.style.display = 'none';
          if (btn) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
        }
      });
  }

  function areAllOptionsSelected(form) {
    var formId = form.getAttribute('id');
    var inputs = document.querySelectorAll('input[type="radio"][form="' + formId + '"][name*="option"]');
    if (!inputs.length) return true; // pas d'options, rien à sélectionner
    var groups = {};
    inputs.forEach(function (i) {
      if (!groups[i.name]) groups[i.name] = { total: 0, checked: 0 };
      groups[i.name].total++;
      if (i.checked) groups[i.name].checked++;
    });
    return Object.keys(groups).every(function (name) {
      return groups[name].checked > 0;
    });
  }

  function scrollToFirstUnselected(form) {
    var formId = form.getAttribute('id');
    var allInputs = document.querySelectorAll('input[type="radio"][form="' + formId + '"][name*="option"]');
    var groups = {};
    allInputs.forEach(function (i) {
      if (!groups[i.name]) groups[i.name] = [];
      groups[i.name].push(i);
    });
    for (var name in groups) {
      var hasChecked = groups[name].some(function (i) { return i.checked; });
      if (!hasChecked && groups[name][0]) {
        var fieldset = groups[name][0].closest('fieldset');
        if (fieldset) {
          fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
          fieldset.classList.add('iris-needs-attention');
          setTimeout(function () {
            fieldset.classList.remove('iris-needs-attention');
          }, 1800);
        }
        return;
      }
    }
  }

  function initForm(form) {
    var formId = form.getAttribute('id');
    // Les inputs variant-picker sont HORS du <form>, liés via attribut form=
    var sizeInputs = document.querySelectorAll('input[type="radio"][form="' + formId + '"][name*="option"]');
    if (!sizeInputs.length) return;

    // Désélectionne tous les radios à l'init
    sizeInputs.forEach(function (i) { i.checked = false; });

    // Efface l'id variant dans le hidden input
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = '';

    // État initial : pas de variante sélectionnée
    setAtcState(formId, false);

    // Listen variant:change (Prestige le dispatche quand une variante est résolue)
    form.addEventListener('variant:change', function (event) {
      var v = event.detail && event.detail.variant;
      setAtcState(formId, !!v && areAllOptionsSelected(form));
    });

    // Listen changements d'options (inputs sont HORS du form, on listen sur chacun)
    sizeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!areAllOptionsSelected(form)) {
          setAtcState(formId, false);
        }
      });
    });

    // Intercepte le submit pour bloquer si pas de variante
    form.addEventListener('submit', function (event) {
      if (!areAllOptionsSelected(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollToFirstUnselected(form);
      }
    }, true);
  }

  function init() {
    var forms = document.querySelectorAll('form[id^="product-form"]');
    if (!forms.length) {
      return setTimeout(init, 150);
    }
    forms.forEach(initForm);
  }

  // Attendre load pour être sûr que variant-picker custom element est attaché
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
